// Components
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import AddUserToGroupButton from '../components/AddUserToGroupButton';
import DeleteUserFromGroupButton from '../components/DeleteUserFromGroupButton';
import ManageGroupPoliciesButton from '../components/ManageGroupPoliciesButton';
import LoadingSpinner from './LoadingSpinner';

// To handle requests
import GroupsAPI from '../utils/GroupsAPI';

// CSS
import '../components/Panel.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

const DEFAULT_MAX_ITEMS = 20;

class GroupDetailsComponent extends Component {

    constructor() {
        super();

        const nbItemsPagination = JSON.parse(
          localStorage.getItem('scality-nbitems-group-users')
        );
        this.state = {
            groupUsers: [],
            filterText: '',
            selectedUsers: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            nbItems: nbItemsPagination || DEFAULT_MAX_ITEMS,
            dataLoaded: false,
        };
        this.refresh = this.refresh.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handlePreviousPage = this.handlePreviousPage.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleUserAction = this.handleUserAction.bind(this);
        this.setSelectedUser = this.setSelectedUser.bind(this);
        this.selectAllUsers = this.selectAllUsers.bind(this);
    }

    // Add a user to selection
    setSelectedUser(username) {
        const tmp = this.state.selectedUsers;

        if (tmp.indexOf(username) >= 0) {
            tmp.splice(tmp.indexOf(username), 1);
        } else {
            tmp.push(username);
        }
        this.setState({ selectedUsers: tmp });
    }

    // Select all users
    selectAllUsers() {
        const tmp = [];
        const idx = this.state.currentIndex;
        const selectedUsers = this.state.selectedUsers;

        for (let i = 0; i < this.state.groupUsers[idx].length; i++) {
            tmp.push(this.state.groupUsers[idx][i].UserName);
        }
        this.setState({ selectedUsers: selectedUsers.concat(tmp) });
    }

    componentWillMount() {
        this.refresh(this.props.group.GroupName);
    }

    componentWillReceiveProps(nextProps) {
        // On new props, refresh the call to the API with new group name
        // This could occur if th user clicks on another
        // group without closing the first panel
        this.setState({
            groupUsers: [],
            filterText: '',
            selectedUsers: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
            dataLoaded: false,
        });
        this.refresh(nextProps.group.GroupName);
    }

    // groupname is retrieved from parameter and not from props
    // to update more efficiently if props are changing
    // through the componentWillReceiveProps method
    refresh(groupName) {
        GroupsAPI.getGroup(groupName, this.state.nbItems, this.state.marker)
        .then(res => {
            const userPages = this.state.groupUsers;
            res.users.sort((a, b) => {
                if (a.UserName < b.UserName) {return -1;}
                if (a.UserName > b.UserName) {return 1;}
                return 0;
            });
            userPages.push(res.users);
            this.setState({
                groupUsers: userPages,
                marker: res.marker,
                maxIndex: res.marker ? -1 : this.state.currentIndex,
                dataLoaded: true,
            });
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
        });
    }

    handleFilterChange(e) {
        this.setState({ filterText: e.target.value });
    }

    handlePreviousPage() {
        this.setState({
            currentIndex: this.state.currentIndex - 1,
        });
    }

    handleNextPage() {
        const currentIndex = this.state.currentIndex;
        this.setState({
            currentIndex: this.state.currentIndex + 1,
        });
        if (currentIndex + 1 === this.state.groupUsers.length) {
            this.refresh(this.props.group.GroupName);
        }
    }

    handleUserAction() {
        this.setState({
            groupUsers: [],
            filterText: '',
            selectedUsers: [],
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
        }, () => {
            this.refresh(this.props.group.GroupName);
        });
    }

    handleNbItemsSelect(event) {
        localStorage.setItem('scality-nbitems-group-users',
        JSON.stringify(event.target.value));
        this.setState({
            nbItems: event.target.value,
            groupUsers: [],
            filterText: '',
            currentIndex: 0,
            maxIndex: -1,
            marker: null,
        }, () => {
            this.refresh(this.props.group.GroupName);
        });
    }

    getUserRow(user) {
        let selectedBadge = null;
        if (this.state.selectedUsers.indexOf(user.UserName) >= 0) {
            selectedBadge = <span
              className="badge"
              style={brandingStyles.buttons.default}
            >
                <i className="fa fa-check-square-o"></i>
                &nbsp;Selected
            </span>;
        }


        if (!this.state.filterText
          || (this.state.filterText.length
          && (user.UserName.indexOf(this.state.filterText) !== -1))) {
            return (
                <li className="list-group-item group-user-row clickable"
                  key={user.UserId}
                  style={Object.assign(
                    { borderRadius: '0px' },
                    brandingStyles.backgrounds.panel
                  )}
                  onClick={this.setSelectedUser.bind(this, user.UserName)}>
                    <i
                      className="fa fa-user-circle pull-left"
                      style={brandingStyles.mainColor}
                    ></i>
                    <strong>{user.UserName}</strong>
                    <br/>
                    <i>{user.Arn}</i>
                    {selectedBadge}
                    <div className="clearfix" />
                </li>
            );
        }
        return null;
    }

    render() {
        const styles = {
            // Used for togging display of the button
            selectAllUsersButton: {},
        };

        let usersList;
        const currentUsers = this.state.groupUsers[this.state.currentIndex];
        if (currentUsers) {
            // Map over the contacts and get an element for each of them
            usersList = currentUsers.map(user => this.getUserRow(user));
            if (usersList.length === 0) {
                styles.selectAllUsersButton.display = 'none';
            }
        }

        const prevDisabled = this.state.currentIndex === 0;
        const nextDisabled = this.state.currentIndex === this.state.maxIndex;

        const pagerInstance = (
          <ul className="pager padding-l-15 padding-r-15">
            <li
              className={prevDisabled ? 'previous disabled' : 'previous'}
            >
              <a
                className="clickable"
                onClick={this.handlePreviousPage}
                style={brandingStyles.buttons.primary}
              >&larr;</a>
            </li>
            <li
              className={nextDisabled ? 'next disabled' : 'next'}
            >
              <a
                className="clickable"
                onClick={this.handleNextPage}
                style={brandingStyles.buttons.primary}
              >&rarr;</a>
            </li>
          </ul>
        );

        return (
            <div
              className="panel panel-default"
              style={brandingStyles.backgrounds.panel}
            >
                <div
                  className="panel-heading"
                  style={brandingStyles.backgrounds.panelHeader}
                >
                    <h4>
                        <i
                          className="fa fa-users"
                          style={brandingStyles.mainColor}
                        ></i>
                        &nbsp; {this.props.group.GroupName}
                        &nbsp;details
                        <i
                            className="fa fa-times pull-right clickable"
                            style={brandingStyles.mainColor}
                            onClick={this.props.unselect.bind(this, null)}
                        ></i>
                    </h4>

                </div>

                <div className="panel-body">
                    <div>
                    <select
                       className="pull-right form-control pagination-select"
                       style={brandingStyles.backgrounds.input}
                       value={this.state.nbItems}
                       onChange={this.handleNbItemsSelect.bind(this)}>
                         <option value="20">20</option>
                         <option value="50">50</option>
                         <option value="100">100</option>
                    </select>
                      <AddUserToGroupButton
                        groupname={this.props.group.GroupName}
                        callback={this.handleUserAction}/>
                      <button
                        className="btn btn-primary margin-b-10 margin-r-10"
                        style={
                          Object.assign(
                            {},
                            styles.selectAllUsersButton,
                            brandingStyles.buttons.primary
                          )
                        }
                        onClick={this.selectAllUsers}
                      >
                          <i className="fa fa-check-square-o"></i>
                          &nbsp;Select all
                      </button>
                      <ManageGroupPoliciesButton
                        groupName={this.props.group.GroupName}
                      />
                      <div>
                        {this.state.selectedUsers.length
                          && <DeleteUserFromGroupButton
                          users={this.state.selectedUsers}
                          groupname={this.props.group.GroupName}
                          callback={this.handleUserAction}/>
                          || null}
                      </div>
                    </div>
                    <input type="text"
                      className="form-control full-width margin-t-10"
                      placeholder="Find users"
                      value={this.state.filterText}
                      onChange={this.handleFilterChange}
                      style={brandingStyles.backgrounds.input}
                    />
                    <ul className="list-group">
                        {this.state.dataLoaded ? usersList : <LoadingSpinner />}
                    </ul>
                    {pagerInstance}
                </div>
            </div>
        );
    }
}

GroupDetailsComponent.propTypes = {
    // Group to display
    group: PropTypes.object.isRequired,
    // close the component by unselecting parent component group
    unselect: PropTypes.func.isRequired,
};

export default GroupDetailsComponent;



/** WEBPACK FOOTER **
 ** ./src/components/GroupDetails.js
 **/